import React from 'react';
import Link from 'gatsby-link';

import github from '../img/github-icon.svg';
import logo from '../img/sjs-logo.svg';

const Footer = (events) => (
    <section className="section footer-section">
        <div className="container">
        <div className="columns">
          <div className="column">
            <h3>Company</h3>
            <p><Link to="/about">About Us</Link><br />
            <Link to="/careers">Careers</Link><br />
</p>
          </div>
          <div className="column">
            <h3>Connect</h3>
            <p>
            <a href="https://www.linkedin.com/company/san-juan-software" target="_blank">
              <span className="icon is-large">
                <i className="mdi mdi-36px mdi-linkedin"></i>
              </span>
            </a>
            <a href="https://twitter.com/drewgislason" target="_blank">
              <span className="icon is-large">
                <i className="mdi mdi-36px mdi-twitter"></i>
              </span>
            </a>
</p>
            </div>
          <div className="column is-half">
            <h3>Upcoming Events</h3>
            <p>
            {events.events.slice(-3).map((event, index) => (
              <a key={"event-" + index} href={event.link} target="_blank">{event.startDate} {event.title}, {event.date} {event.location}<br /></a>
            ))}
            <Link to="/events"><em>All Events</em></Link></p>
          </div>
        </div>
        </div>
      </section>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js